import React, { PropsWithChildren } from "react";

import ModalCloseIcon from "~/icons/ModalCloseIcon";

import styles from "./EmptyModal.module.css";

type EmptyModalProps = {
  hideCloseButton?: boolean;
  visible: boolean;
  onClose: VoidFunction;
};

const EmptyModal: React.FC<PropsWithChildren<EmptyModalProps>> = ({
  hideCloseButton = false,
  visible,
  onClose,
  children,
}) => {
  return visible ? (
    <div className={styles.backdrop} onClick={onClose}>
      <div className={styles.modal} onClick={(e) => e.stopPropagation()}>
        {!hideCloseButton && (
          <div className={styles.closeButton} onClick={onClose}>
            <ModalCloseIcon />
          </div>
        )}
        {children}
      </div>
    </div>
  ) : null;
};

export default EmptyModal;
